var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M26 15.0105V9.9105C26 9.07042 26 8.65038 25.8365 8.32951C25.6927 8.04727 25.4632 7.8178 25.181 7.67399C24.8601 7.5105 24.4401 7.5105 23.6 7.5105H5M20 22.5105V27.6105C20 28.4506 20 28.8706 19.8365 29.1915C19.6927 29.4737 19.4632 29.7032 19.181 29.847C18.8601 30.0105 18.4401 30.0105 17.6 30.0105H5M5 3.7605L5 33.7605M5 22.5105L29.6 22.5105C30.4401 22.5105 30.8601 22.5105 31.181 22.347C31.4632 22.2032 31.6927 21.9737 31.8365 21.6915C32 21.3706 32 20.9506 32 20.1105V17.4105C32 16.5704 32 16.1504 31.8365 15.8295C31.6927 15.5473 31.4632 15.3178 31.181 15.174C30.8601 15.0105 30.4401 15.0105 29.6 15.0105L5 15.0105L5 22.5105Z",
    stroke: "#ABCA72",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicon);
export default __webpack_public_path__ + "static/media/graph.icon.d7bdf38d35dfcaa32e68a0837cc3da8a.svg";
export { ForwardRef as ReactComponent };